import { featured } from "@/mocks/dramaData";

export default function Featured() {
  return (
    <section id="featured" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <span className="mb-3 inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-bold text-secondary-900">
              <i className="ri-vip-diamond-line"></i> 热门专题
            </span>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-4xl">
              不只是吃瓜，更要看得懂
            </h2>
            <p className="mt-3 max-w-2xl text-sm text-foreground-700 md:text-base">
              精选本月高热度现象做深度拆解，从事件表面延伸到行业逻辑。
            </p>
          </div>
          <a href="#about" className="group flex cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700">
            查看网站定位
            <i className="ri-arrow-right-line transition group-hover:translate-x-1"></i>
          </a>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {featured.map((f, i) => (
            <article
              key={f.title}
              className={`group flex cursor-pointer flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-100/60 transition hover:-translate-y-1 ${
                i === 0 ? "md:col-span-2 lg:col-span-1" : ""
              }`}
            >
              <div className="relative h-44 w-full overflow-hidden md:h-48">
                <img
                  src={f.image}
                  alt={f.title}
                  className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-background-50/90 px-3 py-1 text-[11px] font-bold text-primary-700 backdrop-blur">
                  {f.cat}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <i className="ri-eye-line"></i>
                  <span>{f.reads} 次阅读</span>
                </div>
                <h3 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-700 md:text-lg">
                  {f.title}
                </h3>
                <p className="mt-2 line-clamp-3 text-sm leading-relaxed text-foreground-600">{f.desc}</p>
                <span className="mt-auto inline-flex items-center gap-1 pt-4 text-sm font-semibold text-accent-600">
                  阅读专题
                  <i className="ri-arrow-right-line transition group-hover:translate-x-1"></i>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}